import { Redirect } from "expo-router";

export default function Route() {
  return <Redirect href="/" />;
}
